/* Native details remain usable without JavaScript. Animation is delegated so
   newly rendered Shopify variant sections work without reinitialization. */
(()=>{
 const active=new WeakMap();
 document.addEventListener('click',event=>{
  const summary=event.target.closest?.('details.cc-disclosure > summary, details.cc-filter-group > summary');
  if(!summary)return;
  const details=summary.parentElement;
  if(!details.animate)return;
  event.preventDefault();
  const wasOpen=details.dataset.expanded===undefined?details.open:details.dataset.expanded==='true';
  const opening=!wasOpen,startHeight=details.getBoundingClientRect().height;
  const previous=active.get(details);if(previous){previous.onfinish=null;previous.cancel();}
  details.dataset.expanded=String(opening);
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){details.open=opening;details.style.height='';details.style.overflow='';active.delete(details);return;}
  details.open=true;details.style.height='';
  const target=opening?details.getBoundingClientRect().height:summary.getBoundingClientRect().height;
  details.style.overflow='hidden';
  const animation=details.animate([{height:startHeight+'px'},{height:target+'px'}],{duration:opening?300:250,easing:'cubic-bezier(.25,.8,.25,1)'});
  active.set(details,animation);
  animation.onfinish=()=>{if(active.get(details)!==animation)return;details.open=opening;details.style.height='';details.style.overflow='';active.delete(details);};
 });
})();
